import authenticationModule from "./authentication/authentication.module";
import eventsModule from "./events/events.module";
import listsModule from "./lists/lists.module";
import sectionsModule from "./sections/sections.module";
import fillParamsModule from "./fillParams/fillParams.module";
import messagesModule from "./messages/messages.module";
import resetFieldsModule from "./resetFields/resetFields.module";
import cityHandlerModule from "./cityHandler/cityHandler.module";
import actionListsModule from "./actionLists/actionLists.module";
import formatterModule from "./formatter/formatter.module";
import transactionsOpsModule from "./transactionsOps/transactionsOps.module";
import socketModule from "./socket/socket.module";
import mapieModule from "./mapie/mapie.module";
import collectUserDataModule from "./collectUserData/collectUserData.module";
import slackFormatterModule from "./slackFormatter/slackFormatter.module";
import realtimeRideModule from "./realtimeRide/realtimeRide.module";
import permissionsModule from "./permissions/permissions.module";
import chartieModule from "./chartie/chartie.module";
import scheduleModule from "./schedule/schedule.module";
import auditorHandlerModule from "./auditorHandler/auditorHandler.module";
import rougenaModule from "./rougena/rougena.module";
import purecloudModule from "./purecloud/purecloud.module";
import stopWatchModule from "./stopWatch/stopWatch.module";
import getCurrencyModule from "./getCurrency/getCurrency.module";
import googleMapsModule from "./googleMaps/googleMaps.module";
import corporateInvoiceExportModule from "./corporateInvoiceExport/corporateInvoiceExport.module";
import translationModule from "./translation/translation.module";
import googleAuthModule from "./googleAuth/googleAuth.module";
import googleAnalyticsModule from "./googleAnalytics/googleAnalytics.module";

const servicesModule = angular.module("app.services", [
  authenticationModule.name,
  eventsModule.name,
  listsModule.name,
  sectionsModule.name,
  fillParamsModule.name,
  messagesModule.name,
  resetFieldsModule.name,
  cityHandlerModule.name,
  actionListsModule.name,
  formatterModule.name,
  transactionsOpsModule.name,
  socketModule.name,
  mapieModule.name,
  collectUserDataModule.name,
  slackFormatterModule.name,
  realtimeRideModule.name,
  permissionsModule.name,
  chartieModule.name,
  scheduleModule.name,
  auditorHandlerModule.name,
  rougenaModule.name,
  purecloudModule.name,
  stopWatchModule.name,
  getCurrencyModule.name,
  googleMapsModule.name,
  corporateInvoiceExportModule.name,
  translationModule.name,
  googleAuthModule.name,
  googleAnalyticsModule.name,
]);

export default servicesModule;



// WEBPACK FOOTER //
// ./src/services/index.js